module.exports = __webpack_public_path__ + "static/RegisterApp-f82abbca15367c35ef3421ec815b4773.png";